import script from "./Branches.vue?vue&type=script&setup=true&lang=js"
export * from "./Branches.vue?vue&type=script&setup=true&lang=js"

import "./Branches.vue?vue&type=style&index=0&id=6a38e9e2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a38e9e2"]])

export default __exports__